import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projects: {
		defaultMessage: 'Projects',
		id: 'atlassian-navigation.projects.projects',
		description: 'Projects',
	},
});
